import {
  GlobalCartRoutes,
  GlobalProductBarcodeScannerRoutes,
  GlobalRegistrationRoutes,
  GlobalSearchRoutes
} from '@hdms/shared/common-types';

export const URLS = {
  cart: `/${GlobalCartRoutes.BASE}`,
  search: `/${GlobalSearchRoutes.BASE}?text=`,
  stores: '/stores',
  barcodeScan: `/${GlobalProductBarcodeScannerRoutes.BASE}`,
  accountRegistration: `/${GlobalRegistrationRoutes.BASE}/${GlobalRegistrationRoutes.ACCOUNT}`
};

export const OPENSEARCH_AUTOSUGGEST_CATEGORIES_TOGGLE = 'ldt_autosuggest_categories_opensearch';
